<template>
  <div class="service">
    <div class="banner">
      <div class="banner_title">
        <h1>五有服务</h1>
        <p>SERVICE OF FIVE</p>
      </div>
    </div>
    <div class="service_bd">
      <LeftNav
        title="五有服务"
        :list="list"
        @event1="change($event)"
        bigTitle="BOTING LIVING CLUB"
         :key="changing"
           :newData="newData"
      ></LeftNav>
      <div class="bd_right">
        <router-view></router-view>
        <!-- <fuWuItem1
          title="五有服务"
          :list="list"
          :newData="newData"
          v-if="newData == 0"
        ></fuWuItem1>
        <fuWuItem2
          title="五有服务"
          :list="list"
          :newData="newData"
          v-if="newData == 1"
        ></fuWuItem2>
        <fuWuItem3
          title="五有服务"
          :list="list"
          :newData="newData"
          v-if="newData == 2"
        ></fuWuItem3>
        <fuWuItem4
          title="五有服务"
          :list="list"
          :newData="newData"
          v-if="newData == 3"
        ></fuWuItem4>
        <fuWuItem5
          title="五有服务"
          :list="list"
          :newData="newData"
          v-if="newData == 4"
        ></fuWuItem5> -->
      </div>
    </div>
  </div>
</template>
  <script>
import LeftNav from "../components/leftNav.vue";

export default {
  name: "service",
  data() {
    return {
      changing:0,
      list: [
        {
          title: "【五有】有套房",
          small_title: "HAVE A SUITE",
          hasTitle: "有套房",
          option:'1'
        },
        {
          title: "【五有】有块地",
          hasTitle: "有块地",
          option:'0.75'
        },
        {
          title: "【五有】有地暖",
          hasTitle: "有地暖",
          option:'0.3'
        },
        {
          title: "【五有】有社团",
          small_title: "HAVE A CLUB",
          hasTitle: "有社团",
          option:'0.1'
        },
        {
          title: "【五有】有管家",
          small_title: "HAVE A BUTLER",
          hasTitle: "有管家",
          option:'0.1'
        },
      ],
      newData: 0,
    };
  },
  methods: {
    change(data) {
      this.newData = data;
       this.changing+=1;
     
    },
  },
  mounted: function () {
    // this.$router.push({ path: "/Service/fuWuItem1" });
  },
  components: {
    LeftNav,
  },
  watch: {
    newData: {
      handler: function () {
        //do something
        // console.log()
        if (this.newData == 0&&window.location.href.indexOf("/Service/fuWuItem1")==-1) {
          this.$router.push({ path: "/Service/fuWuItem1" });
        } else if (this.newData == 1&&window.location.href.indexOf("/Service/fuWuItem2")==-1) {
          this.$router.push({ path: "/Service/fuWuItem2" });
        } else if (this.newData == 2&&window.location.href.indexOf("/Service/fuWuItem3")==-1) {
          this.$router.push({ path: "/Service/fuWuItem3" });
        } else if (this.newData == 3&&window.location.href.indexOf("/Service/fuWuItem4")==-1) {
          this.$router.push({ path: "/Service/fuWuItem4" });
        } else if (this.newData == 4&&window.location.href.indexOf("/Service/fuWuItem5")==-1) {
          this.$router.push({ path: "/Service/fuWuItem5" });
        }
      },
      deep: true,
    },
      $route: {
      handler(newRouter) {
 
          if (newRouter.path == "/Service/fuWuItem1") {
          this.newData = 0;
        } else if (newRouter.path == "/Service/fuWuItem2") {
           this.newData = 1;
        }else if (newRouter.path == "/Service/fuWuItem3") {
           this.newData = 2;
        }else if (newRouter.path == "/Service/fuWuItem4") {
           this.newData = 3;
        }else if (newRouter.path == "/Service/fuWuItem5") {
           this.newData = 4;
        }
      },immediate: true,}
  },
};
</script>
<style scoped="scoped">
.banner {
  width: 100%;
  height: 8.75rem;
  background-image: url("../assets/image/fuwu/banner.png");
  background-size: 100% 100%;
  position: relative;
}
.banner_title {
  position: absolute;
  left: 2.5rem;
  bottom: 2.125rem;
  width: 5.6625rem;
  height: 2.6375rem;
  background-color: rgba(64, 104, 76, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 0.4875rem;
}
.banner_title h1 {
  font-size: 0.65rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.banner_title p {
  font-size: 0.4rem;
  font-family: Century Gothic;
  font-weight: 400;
  color: #ffffff;
}
.service_bd {
  padding: 0.75rem 2.5rem 0;
  display: flex;
  justify-content: space-between;
}
.bd_right {
  width: 12.6rem;
  padding-bottom: 4.4125rem;
}
</style>